module.exports = __webpack_public_path__ + "img/wss_warspacefund.9f4c85d.png";